import { useState, useCallback, useMemo } from "react";

export const defaultFilters = {
  text: "",
  department: "",
  location: "",
};

const transformOption = (value, index) => ({
  id: index,
  label: value,
  value,
});

const useJobs = (defaultJobs) => {
  const [filters, setFilters] = useState(defaultFilters);
  const applyDepartmentFilter = (job) =>
    filters.department === "" || job?.department === filters?.department;

  const applyLocationFilter = (job) =>
    filters.location === "" || job?.location === filters?.location;

  const applyTextFilter = (job) =>
    (job.searchText || "")
      .toLowerCase()
      .includes((filters.text || "").toLowerCase());

  const onChange = useCallback((key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  }, []);

  const filteredJobs = useMemo(
    () =>
      (defaultJobs || []).filter((job) => {
        return (
          applyDepartmentFilter(job) &&
          applyLocationFilter(job) &&
          applyTextFilter(job)
        );
      }),
    [defaultJobs, filters],
  );

  const uniqueDepartments = useMemo(
    () =>
      Array.from(
        new Set(
          (defaultJobs || [])
            .map((job) => job.department || "")
            .filter((department) => department.trim() !== ""),
        ),
      ).map(transformOption),
    [defaultJobs],
  );

  const uniqueLocations = useMemo(
    () =>
      Array.from(
        new Set(
          (defaultJobs || [])
            .map((job) => job.location || "")
            .filter((location) => location.trim() !== ""),
        ),
      ).map(transformOption),
    [defaultJobs],
  );

  const defaults = useMemo(
    () => ({ department: uniqueDepartments, location: uniqueLocations }),
    [uniqueDepartments, uniqueLocations],
  );

  return {
    filters,
    onChange,
    jobs: filteredJobs,
    defaults,
  };
};

export { useJobs };
